export default "__VITE_ASSET__n3S58xQU__"